import { Injectable } from '@angular/core';
import { SecureApi } from '../../core/secure.api';

@Injectable()
export class FeelingsRatingService {

    constructor(
        public secureApi: SecureApi
    ) { }

    getItems(token: string, itemPerPage) {
        return this.secureApi.get('feelings-rating/' + token + '/' + itemPerPage);
    }

    submit(token: string, feelings: Array<Object>, activePage = 0, itemPerPage = 12) {
        let body = '';
        for (let feeling in feelings) {
            if (feelings.hasOwnProperty(feeling)) {
                body += 'rating[' + feelings[feeling]['id'] + ']=' + feelings[feeling]['rating_by_patient'] + '&';
            }
        }
        body += 'activePage=' + activePage;
        body += '&itemPerPage=' + itemPerPage;
        return this.secureApi.post('feelings-rating/' + token, body, true);
    }
}
